import Spinning from "./spinning";

export default function LoadingMain() {
  return (
    <div className="flex justify-center pt-20 h-screen"><Spinning/></div>
  )
}
